import { render } from "./Replacement.vue?vue&type=template&id=bc958202&scoped=true"
import script from "./Replacement.vue?vue&type=script&lang=js"
export * from "./Replacement.vue?vue&type=script&lang=js"

import "./Replacement.vue?vue&type=style&index=0&id=bc958202&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc958202"]])

export default __exports__